import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
// import { ReactKeycloakProvider } from "@react-keycloak/web";
import { AuthProvider } from 'react-oidc-context';
// eslint-disable-next-line import/no-named-as-default
import App from './App';
import { UserProvider } from './context/UserContext';
// import getKeycloakInstance from "./config/keycloak";
// import keycloak from "./config/keycloak";
import './i18n/config';
import reportWebVitals from './reportWebVitals';
import { oidcConfig } from './config/oidcConfig';

import { AuthProvider as AuthOstProvider } from './context/AuthProvider';
import { SessionProvider } from './context/SessionContext';

// const keycloak = getKeycloakInstance();

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <SessionProvider>
    <AuthOstProvider>
      <AuthProvider {...oidcConfig}>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProvider>
    </AuthOstProvider>
    ,
  </SessionProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
